import { testimonials } from '@/mocks/testimonials';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: rating }).map((_, i) => (
        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-label tracking-widest uppercase text-foreground-400">
              Community Feedback
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Trusted by<br />
            Smart Shoppers
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto">
            See what our community says about using CSSBuy spreadsheet resources
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-lg p-6 md:p-7 flex flex-col"
            >
              <StarRating rating={t.rating} />
              <h4 className="text-foreground-900 font-heading font-semibold text-base mt-4 mb-2">
                {t.title}
              </h4>
              <p className="text-foreground-500 text-sm leading-relaxed flex-1 mb-5">
                {t.content}
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-background-200">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-foreground-900 text-sm font-semibold">
                    {t.name}
                  </p>
                  <p className="text-foreground-400 text-xs">
                    {t.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}